import React from "react";

function About() {
  return (
    <div name="about" className="about-div1">
      <div className="about-div2">
        <div className="about-div3">
            <div className="about-div4">
                <p className="about-p">
                About
                </p>
            </div>
            <div></div>
            </div>
            <div className="about-div5"> 
            <div className="about-div6">
                <p>I have a real passion for collaborating, creativity and people. </p>
            </div>
            <div>
                <p className="font-light my-1 mx-4"> 
                Before deciding to dive head first into a career in tech, I spent 15 years as a Photography Producer, managing and seeking out new business opportunities in advertising for commercial photographers. This helped me develop strong analytical, problem solving and people skills within a creative environment, which I really enjoy.
                </p>
                <br></br>
                <p className="font-light my-1 mx-4">I can learn and adapt to new and complex challenges quickly, and aim to continue growing and evolving.
                I'm keen to find my voice within the right tech role, where I can add value to a team. Ultimately, I'd love to continue developing my skills working on products and experiences that bring value to people's lives.</p>
                <br></br>
                <p className="font-light my-1 mx-4">
                I'm passionate about music, and I love discovering new music and going to live shows. I'm also a keen football/sports fan, enjoy good food and wine, art/design, architecture, film and reportage photography.
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default About;
